import { RouterView, type RouterOptions } from "vue-router";

const names = {
  people: "Person.People",
  list: "Person.PersonList",
  new: "Person.PersonNew",
  view: "Person.PersonView",
  edit: "Person.PersonEdit",
};

export { names as personRouteNames };

const personRoutes: RouterOptions["routes"] = [
  {
    path: "/person",
    name: names.people,
    component: { render: () => <RouterView /> },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "People" },
        component: () => import("./PersonList.vue"),
      },
      {
        path: "new",
        name: names.new,
        meta: { title: "New Person", isNew: true, isForm: true },
        component: () => import("./PersonEdit.vue"),
      },
      {
        path: ":id(\\d+)/view",
        name: names.view,
        meta: { title: "Person View" },
        component: () => import("./PersonView.vue"),
      },
      {
        path: ":id(\\d+)/edit",
        name: names.edit,
        meta: { title: "Person Edit", isForm: true },
        component: () => import("./PersonEdit.vue"),
      },
    ],
  },
];

export default personRoutes;
